import { UnicornIcon } from './UnicornIcon';

/**
 * author: Colton Wiscombe
 * id B3A5FE32-259C-4FBA-B6EB-A4A1CE7590DE
 * name unicorn
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/unicorn.svg
 * tags
 * - Animal 
 */
export const FantasyIcon = UnicornIcon;
export default FantasyIcon